export const SET_ADMIN_USER = 'ADMIN_USER/SET_ADMIN_USER'
export const SET_ADMIN_USERS = 'ADMIN_USER/SET_ADMIN_USERS'
export const SET_ROLES = 'ADMIN_USER/SET_ROLES'
export const SET_PERMISSIONS = 'ADMIN_USER/SET_PERMISSIONS'
export const SET_TAGS_LIST = 'ADMIN_USER/SET_TAGS_LIST'
